import {del, get, post, put} from './capitalAxios';

const BASE = '/api/v1/account-source';

export const findAllSources = () => get(BASE);
export const createSource = (body) => post(BASE, body);
export const updateSource = (id, body) => put(`${BASE}/${id}`, body);
export const deleteSource = (id) => del(`${BASE}/${id}`);